import React, { useState, useEffect } from"react";
import { useNavigate } from"react-router-dom";
import Editor from"@monaco-editor/react";
import axios from"axios";

const HuntLevel2 = () => {
 const [query, setQuery] = useState("");
 const [output, setOutput] = useState("");
 const [startTime] = useState(Date.now());
 const [elapsedTime, setElapsedTime] = useState(0);
 const [showShelf, setShowShelf] = useState(false);
 const [clueRevealed, setClueRevealed] = useState(false);

 const navigate = useNavigate();

 useEffect(() => {
 const timer = setInterval(() => {
 setElapsedTime(Math.floor((Date.now() - startTime) / 1000));
 }, 1000);
 return () => clearInterval(timer);
 }, [startTime]);

 const handleSubmit = async () => {
 try {
 const response = await axios.post("http://localhost:5000/api/hunt/submit/2", { query });
 if (response.data.success) {
 setOutput(response.data.message);
 setShowShelf(true); // show book shelf instead of direct clue
 } else {
 setOutput(response.data.message);
 }
 } catch (err) {
 setOutput("Server error.");
 }
 };

 return (
 <div className="min-h-screen bg-bgMain text-gold p-8">
 <h1 className="text-3xl font-bold mb-4">Level 2: The Book Ledger</h1>
 <p className="mb-6 text-white">
 A digital ledger may contain the truth. Find the last unaltered book entry on <strong>shelf 14</strong>.
 <br />
 Use SQL to locate it.
 </p>

 <div className="mb-2 text-sm text-muted">⏱ Time Elapsed: {elapsedTime}s</div>

 <div className="bg-[#1e1e1e] rounded-md mb-4">
 <Editor
 height="250px"
 defaultLanguage="sql"
 theme="vs-dark"
 value={query}
 onChange={(value) => setQuery(value)}
 />
 </div>

 <button
 onClick={handleSubmit}
 className="mt-4 bg-primary text-white px-6 py-2 rounded-md hover:bg-secondary transition"
 >
 Submit Query
 </button>

 <div className="mt-4 bg-[#111] p-4 rounded-md">
 <h3 className="text-white font-semibold">Output:</h3>
 <pre className="text-green-400 whitespace-pre-wrap">{output}</pre>
 </div>

 {showShelf && (
 <div className="mt-8">
 <h2 className="text-xl text-white font-semibold mb-4 flex items-center gap-2">
 📚 Pick the book from the shelf
 </h2>

 <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
 {[
"Dream Engine",
"Cold Script",
"The Mirror Verse",
"Binary Ashes",
"The Last Truth", // correct one
"Shattered Keys",
"Echo Chamber",
"Dark Lineage"
 ].map((title) => (
 <div
 key={title}
 onClick={() => {
 if (title ==="The Last Truth") {
 setClueRevealed(true);
 } else {
 alert("📕 This book has nothing.");
 }
 }}
 className="bg-[#1a1a1a] border border-primary rounded-lg text-white text-sm font-mono px-4 py-10 text-center cursor-pointer shadow-md hover:shadow-yellow-400 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
 >
 {title}
 </div>
 ))}
 </div>

 {clueRevealed && (
 <div className="mt-8 bg-[#111] p-6 rounded-md border border-green-500 shadow-lg">
 <h2 className="text-lg font-bold text-white mb-2">🗝 Clue Found Inside the Book!</h2>
 <p className="text-white text-sm mb-4">
"Voices don’t always echo through walls. <br />
 Check the log backup. <br />
 Timestamp: <strong>2:03</strong> — Left channel only."
 <br />
 <em>log_backup_EW203.wav</em>
 </p>

 <img
 src="/clues/clue3.png"
 alt="Audio Clue"
 className="w-full max-w-md border border-gold rounded-md mb-4"
 />

 <button
 onClick={() => navigate("/hunt/level/3")}
 className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 transition"
 >
 Proceed to Level 3
 </button>
 </div>
 )}
 </div>
)}

 </div>
 );
};

export default HuntLevel2;



